import { render, staticRenderFns } from "./fund-literature-library-panel.vue?vue&type=template&id=5ecf58e9&"
var script = {}
import style0 from "../../../assets/styles/panels/_LiteratureLibraryPanel.scss?vue&type=style&index=0&lang=scss&"
import style1 from "../../../assets/styles/panels/_AccordionPanel.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports